import { render, staticRenderFns } from "./Tutoriais.vue?vue&type=template&id=c414c1e6"
import script from "./Tutoriais.vue?vue&type=script&lang=js"
export * from "./Tutoriais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports